import { Box } from 'style-utils/components/Box';
import { WithLayoutProps } from 'style-utils/withStyledProps/withLayoutProps';

type AppLayoutWrapperProps = {
  children: React.ReactNode;
} & WithLayoutProps;
const AppLayoutWrapper = (props: AppLayoutWrapperProps) => {
  const { children, ...restOfProps } = props;
  return (
    <Box
      w="100%"
      minH="100vh"
      pb="10rem"
      pt="5rem"
      bg={{ _: 'white', desktop: 'pageBg' }}
      {...restOfProps}
    >
      {children}
    </Box>
  );
};

export default AppLayoutWrapper;
